/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import appSettings from '../../../src/appSettings';
import { fetchProductsSuccess, fetchProductsFailure, resetProducts, resetSubproducersInfo } from '../../actions/actions';
import { fetchProducts} from '../../common/services/Services';
import { gwLinkRedirect} from '../../common/services/proxyServices';
import DropdownFilter from '../../components/common/DropdownFilter/DropdownFilter';
import { LoadingComponent} from '../../components';
import { Box, Button, FormControl, Link, MenuItem, Select, Typography, InputLabel } from '@mui/material';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import statesData from '../../json/states.json';
import { formatDate } from '../../common/utilities/CustomFormatUtil';
import { getCurrentPrismId, getSubproducers } from '../../common/utilities/CommonHelperUtil';
import '../../common/theme/CommonStyles.scss';
import './StartQuote.scss';
import HandleFormUtil from '../../common/utilities/HandleFormUtil';
import constants from '../../constants';


const StartQuoteComponent = ({refreshToken, isAgentDropdownOpen, isSubAgentDropdownOpen, setAgentDropdownOpen, setSubAgentDropdownOpen, openGlobalBanner, hideErrorBanner}) => {
  const dispatch = useDispatch();
  const loading = useSelector(state => state.loading);
  const agentData = useSelector((state) => state.agents);
  const contact = useSelector(state => state.contact);
  const subproducersData = useSelector((state) => state.subproducers);
  const productsData = useSelector((state) => state.products);
  const enrollments = useSelector(state => state.enrollments)
  const selectedProfile = useSelector(state => state.selectedProfile);
  const [showNoDataError, setShowNoDataError] = useState(false);
  const [agent, setAgent] = useState('');
  const [subproducer, setSubproducer] = useState('');
  const [effDate, setEffDate] = useState('');
  const [ratingState, setRatingState] = useState(''); 
  const [selectedProduct, setSelectedProduct] = useState('');
  const isButtonDisabled = !(agent && effDate && ratingState && selectedProduct);
  const username = enrollments.length > 0 ? getCurrentPrismId(enrollments) : '';
  const agentSelectRef = useRef(null);

  const {isLoading, setIsLoading, loaderStyle } = HandleFormUtil(null, null, null);

  const handleChange = (event, setStateFunction, dropdownId) => {
    const newValue = event.target.innerText !== undefined && event.target.innerText !== '' ? event.target.innerText : event.target.value;
    if(dropdownId === constants.agent && agent === newValue) {
      return;
    }
    setStateFunction(newValue);
    setShowNoDataError(false);
    switch (dropdownId) {
      case 'agent':
        setSubproducer('');
        dispatch(resetSubproducersInfo());
        setEffDate('');
        setRatingState('');
        setSelectedProduct('');
        dispatch(resetProducts());
        break;
      case 'subproducer':
        setEffDate('');
        setRatingState('');
        setSelectedProduct('');
        dispatch(resetProducts());
        break;
      case 'effDate':
        setRatingState('');
        setSelectedProduct('');
        dispatch(resetProducts());
        break;
      case 'ratingState':
        setSelectedProduct('');
        dispatch(resetProducts());
        break;
      default:
        break;
    }
  };

  const startAQuote = async (gpa, pc, queryParams) => {
    const url = await gwLinkRedirect(username, null, gpa, pc, queryParams);
    return url;
  }

  useEffect(() => {
    dispatch(resetSubproducersInfo());
    if (agent !== '' && agent !== 'None' ) {
      getSubproducers(agent, username, setIsLoading, openGlobalBanner, hideErrorBanner, refreshToken, dispatch);
    }

  }, [agent, dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      if (agent !== '' && effDate !== '' && ratingState !== '') {
        try {
           const { token } = await refreshToken();
          const trimmedAgent = agent.split(',')[0];
          const trimmedSubproducer = subproducer.split(',')[0] === 'None' ? '' : subproducer.split(',')[0] ;
          const data = await fetchProducts(username, ratingState, effDate, trimmedAgent, trimmedSubproducer, token);          
          hideErrorBanner();
          setShowNoDataError(false);
          dispatch(fetchProductsSuccess(data));
        } catch (err) {
          if(err.message && err.message !== '' && !err.message.includes('Error in fetchProducts')){
            setShowNoDataError(true);
          } else {
            openGlobalBanner(err);
          }          
          dispatch(fetchProductsFailure(err));          
        }
      }
    };

    fetchData();
  }, [agent, subproducer, effDate, ratingState, dispatch]); 

  useEffect(() => {
    if (isAgentDropdownOpen && agentSelectRef.current) {
      document.getElementById('agentSelect').scrollIntoView({block: 'center'});
    }
  }, [isAgentDropdownOpen]);

  const handleNavigate = async () => {
    const trimmedAgent = agent.split(',')[0];
    let trimmedSubproducer = subproducer.split(',')[0];
    let queryParams = ''
    let url = '';
    if(selectedProduct !== "") {
      if(selectedProduct.description.toLowerCase() === constants.petHealth) {
        //Check if agent is AllState (302619) in which case prepend A to the subproducer code (per old QC#129373)
        trimmedSubproducer = (trimmedAgent === "302619") ? "A" + trimmedSubproducer:trimmedSubproducer;
        const managingGroupName = agentData.find(agentDetails => agentDetails.mAgentCd === trimmedAgent)?.managingGroupName;
        queryParams = encodeURI(`?brand=ModernLink&senderId=${trimmedSubproducer}&code=${trimmedAgent}&emailId=${contact.emailAddress}&managingGroup=${managingGroupName}`);
        url = appSettings.PET_HEALTH_URL + queryParams;
      } else {
        let encodedEffDate = formatDate(effDate).replace(/\//g, '%2F');
        queryParams = `agencyCode=${trimmedAgent}&ratingEffDate=${encodedEffDate}&ratingState=${ratingState}&producerCode=${trimmedSubproducer}&sectionCode=${selectedProduct.sectionCode}`
        url = selectedProfile?.amsuitePreference?.toLowerCase() !== constants.amsuite ? await startAQuote(false, 'pcNewQuote', queryParams) : await startAQuote('gpaNewQuote', false, queryParams);
      }
    }
    return url;
  };

  async function logout(timeout = 500) {
    try {
      const logoutWindow = window.open(appSettings.SSO_LOGOUT, '_blank');
  
      if (!logoutWindow) {
        throw new Error('Logout window failed to open');
      }
  
      return new Promise((resolve) => {
        setTimeout(() => {
          logoutWindow.close();
          resolve(true);
        }, timeout);
      });
    } catch (error) {
      throw error;
    }
  }

  const clearForm = () => {
    setAgent('');
    setSubproducer('');
    dispatch(resetSubproducersInfo());
    setEffDate('');
    setRatingState('');
    setSelectedProduct('');
    dispatch(resetProducts());
    hideErrorBanner();
    setShowNoDataError(false);
  };

  if (loading) {
    return <LoadingComponent />;
  }
  
  const agentCodes = Object.keys(agentData).length > 0  
    ? Object.values(agentData).map((data) => {      
        const displayName = data && data.mDisplayName ? data.mDisplayName : '';
        return `${data.mAgentCd}, ${displayName}`;
      })
    : [];

  let subAgentCodes = [];
  if (Object.keys(subproducersData).length > 0) {
    subAgentCodes = (subproducersData[0] === undefined || subproducersData[0] === '')
      ? ['None']
      : ['None', ...Object.values(subproducersData).map((data) => {
          const displayName = data && data.mDisplayName ? data.mDisplayName : '';
          return `${data.mSubproducerCd}, ${displayName}`;
        })];
  }
  const products = (Object.keys(productsData).length > 0 ) ? productsData : [];
  return (
    <Box className='startQuote'>
      <Box className='startQuoteCard'>
        <Typography variant='h3' className='startQuote-title'>Start a quote</Typography>
        {showNoDataError &&
          <Box className='no-data-error'>Our records indicate you do not have product authority in this state with the selected effective date. Please <span className="no-data-error-bold">contact American Modern Producer Management</span> via Chat or email your name, agency code, state and product you are attempting to quote to licensingandcontracts@amig.com for assistance. </Box>
        }
        <form
            name="input"
            action={''}
            method="post"
            target="_self"
            onSubmit={async (e) => {
              e.preventDefault();
              try {
                  const redirectURL = await handleNavigate();
                  if (redirectURL) {
                    window.open(redirectURL, '_self');
                  } 
              } catch (error) {
                return null;
              }
            }}
          >
          <Box className='startQuote-field' id='agentSelect' ref={agentSelectRef}>
            <label
              htmlFor='agentnumber'
              className='startQuote-label'>
              Agent number
            </label>
            <FormControl className='primary-select' variant='outlined'>
               { agentCodes &&
                  <DropdownFilter 
                    agentData={agentCodes}
                    handleChange={(event) => handleChange(event, setAgent, 'agent')}
                    isOpen={isAgentDropdownOpen}
                    setDropdownOpen={setAgentDropdownOpen}
                    selectedValue={agent}
                    placeholderText='Enter or select code'
                    >
                  </DropdownFilter>
                }
            </FormControl>
          </Box>
          <Box className='startQuote-field'>
            <Box>
              <label
                htmlFor='subCode'
                className='startQuote-label'>
                Sub-producer code
              </label>
              { isLoading  &&  
                <Box className='loading-box' style={loaderStyle}></Box>
              }
            </Box>
            {(subAgentCodes  && !isLoading ) && 
            <FormControl className='primary-select' variant='outlined'>
                <DropdownFilter 
                    agentData={subAgentCodes}
                    handleChange={(event) => handleChange(event, setSubproducer, 'subproducer')}
                    isOpen={isSubAgentDropdownOpen}
                    setDropdownOpen={setSubAgentDropdownOpen}
                    selectedValue={subproducer}
                    placeholderText='Enter or select code (if applicable)'
                    isDisabled={subAgentCodes.length === 0}
                  >
                </DropdownFilter>
            </FormControl>
            }
          </Box>
          <Box className='startQuote-field'>
            <label
              htmlFor='effDate'
              className='startQuote-label'>
              Effective date
            </label>
            <input
              className={effDate ? 'effectiveDate effectiveDate--has-value' : 'effectiveDate '}
              type='date'
              value={effDate}
              onChange={(e) => handleChange(e, setEffDate, 'effDate')}
            />
          </Box>
          <Box className='startQuote-field'>
            <label
              htmlFor='ratingState'
              className='startQuote-label'>
              Rating state
            </label>
            <FormControl className='primary-select' variant='outlined'>
              {!ratingState &&
              <InputLabel shrink={false} className="placeholder-text">Enter or select state</InputLabel>
              }
              <Select
                MenuProps={{   
                  classes:{paper:'paper-scroll'}   
                }}
                sx={{
                  '& .MuiSvgIcon-root': {
                    color: '#282828',
                  },
                }}  
                IconComponent = {KeyboardArrowDown}
                value={ratingState ?? " "}
                onChange={(e) => handleChange(e, setRatingState, 'ratingState')}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                className='select-dropdown'
                >
                {statesData &&  Object.keys(statesData).map((state) => (
                  <MenuItem className='dropdown-option' key={state} value={state}>
                    {state}                  
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box className='startQuote-field select-product'>
            <label
              htmlFor='selectProduct'
              className='startQuote-label'>
                Product
            </label>
              <FormControl className='primary-select' variant='outlined'>
                {!selectedProduct &&
                  <InputLabel shrink={false} className="placeholder-text">Enter or select product</InputLabel>
                }
                  <Select
                    MenuProps={{   
                      classes:{paper:'paper-scroll'}   
                    }}
                    sx={{
                      "& .MuiSvgIcon-root": {
                        color: "#282828",
                      },
                    }}  
                    IconComponent = {KeyboardArrowDown}
                    value={selectedProduct ?? " "}
                    onChange={(e) => handleChange(e, setSelectedProduct, 'product')}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                    className='select-dropdown'
                    disabled={products.length === 0}
                  >
                {products && products.length > 0 && 
                 products.map((product) => (
                  product?.description && (
                    <MenuItem
                      className='dropdown-option'
                      key={product.description}
                      value={product}
                    >
                      {product.description}
                    </MenuItem>
                  )
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box className='gridButton'>
            <Button className='button-styling' disabled={isButtonDisabled} type="submit" value="Submit">
              Continue
            </Button>
          </Box>
          <Link
              className='clear-link'
              onClick={() => clearForm()}
            >
              <span className='forward-link-text'>Clear Form</span>
            </Link>
        </form>
      </Box>
    </Box>
  );
}

export default StartQuoteComponent;